/**
 * Single source of truth for the LC116 / NCM code formats across the whole
 * so-catalog-fiscal domain — inline table edit, the single-item form
 * (SOCatalogFiscalServiceForm / SOCatalogFiscalProductForm) and the bulk
 * modal (SOCatalogFiscalBulkApplyModal) all call these instead of each
 * carrying its own copy of the regex.
 *
 * Backend format checks (So_ServiceFiscalInput::customValidate() /
 * So_ProductFiscalInput) only check length, not shape — these are the ONLY
 * format gate for these two fields anywhere in the stack, so every write
 * path (inline, modal, bulk) MUST go through them before a POST fires.
 */

/** LC116 service code: 1-2 digits, a dot, exactly 2 digits (e.g. "14.01"). */
export const LC116_CODE_PATTERN = /^\d{1,2}\.\d{2}$/;

/** NCM product code: exactly 8 digits (e.g. "12345678"). */
export const NCM_CODE_PATTERN = /^\d{8}$/;

/**
 * NFS-e padrao NACIONAL's codigo_tributacao_nacional_iss: exactly 6 digits
 * (e.g. "140101"). A taxonomy of its own, NOT derivable from LC116 — see
 * FocusNfeProvider::buildNfsenPayload()'s docblock (backend) for why one
 * LC116 subitem can expand into several distinct 6-digit codes.
 */
export const CODIGO_TRIBUTACAO_NACIONAL_PATTERN = /^\d{6}$/;

export function isValidLc116Code(code: string | null | undefined): boolean {
  return LC116_CODE_PATTERN.test(code || '');
}

export function isValidNcmCode(code: string | null | undefined): boolean {
  return NCM_CODE_PATTERN.test(code || '');
}

export function isValidCodigoTributacaoNacional(code: string | null | undefined): boolean {
  return CODIGO_TRIBUTACAO_NACIONAL_PATTERN.test(code || '');
}
